import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="0.6" y="0.6" width="10.8" height="10.8" rx="1.35" />
    <path d="M3 3.9H9M3 6H7.2M3.1 10.17L4.2 7.87L11.1 11.1" />
  </svg>
);
